import { render, staticRenderFns } from "./ExhibitPhotos.vue?vue&type=template&id=5cfc8232&scoped=true&"
import script from "./ExhibitPhotos.vue?vue&type=script&lang=js&"
export * from "./ExhibitPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc8232",
  null
  
)

export default component.exports